module.exports = __webpack_public_path__ + "assets/main-logo-a72fed.svg";